import React from 'react';
import Item from '../DropdownItem/DropdownItem';
import { IconHeartL, IconMoneyL, IconThumbsUpL } from '../../../../icons';
import config from '../../../../config';
import {
    INTEREST_CARE,
    INTEREST_RIDING,
    INTEREST_WALK,
} from '../../../../marketplace-custom-config';
import DropdownItemWithListingsData from './DropdownItemWithListingsData';

const { listingTypeRider, userTypeHorseowner } = config;

export default () => (
    <>
        <DropdownItemWithListingsData
            heading="Reiter:innen"
            searchParams={{
                pub_type: listingTypeRider,
                pub_activities: [INTEREST_RIDING],
            }}
        />
        <DropdownItemWithListingsData
            heading="Spazierer:innen"
            searchParams={{
                pub_type: listingTypeRider,
                pub_activities: [INTEREST_WALK],
            }}
        />
        <DropdownItemWithListingsData
            heading="Pfleger:innen"
            searchParams={{
                pub_type: listingTypeRider,
                pub_activities: [INTEREST_CARE],
            }}
        />
        <Item name="FindRiderPage">
            <Item.Icon>
                <IconThumbsUpL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Alle Vorteile</Item.Heading>
                <Item.Description>Funktionen im Überblick</Item.Description>
            </Item.Content>
        </Item>
        <Item name="MatchingPage" searchParams={{ role: userTypeHorseowner }}>
            <Item.Icon>
                <IconHeartL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Matching</Item.Heading>
                <Item.Description>So funktioniert es</Item.Description>
            </Item.Content>
        </Item>
        <Item name="PricingPage" searchParams={{ role: userTypeHorseowner }}>
            <Item.Icon>
                <IconMoneyL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Preise</Item.Heading>
                <Item.Description>Volle Transparenz</Item.Description>
            </Item.Content>
        </Item>
    </>
);
